import { createFileRoute } from '@tanstack/react-router';
import LoginPage from '../pages/LoginPage';

// Standalone Harborlight login screen (ported from source). Rendered WITHOUT
// the app shell, exactly like the source's /login route.
export const Route = createFileRoute('/login')({
  component: LoginPage
});
